import React from 'react'
import { useNavigate } from 'react-router-dom'
import WaterAssignMainWorkCard from './WaterAssignMainWorkCard'
import { useAuthState } from '../../../../../Helper/Context'

export default function WaterAssignMainWorkCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId } = props
    const navigate = useNavigate()

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const WaterAssignMainWorkCardNavigate1 = (name, screenFlag) => {
        if (name === "Operation Pending") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=OperationPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Operation Completed") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=OperationCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Electric Pending") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=ElectricalPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Electric Completed") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=ElectricalCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Mechanical Pending") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=MechanicalPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Mechanical Completed") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=MechanicalCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Civil Pending") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=CivilPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
        else if (name === "Civil Completed") {
            navigate(`/commonforallassignworkmaintainancepagedata?name=${name}&ApiFlag=CivilCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }

    return (
        <div className="row ml-lg-0 ml-0 mr-0 mb-lg-0">
            <div className="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0">
                <WaterAssignMainWorkCard
                    title="Operation Works"
                    title1="Operation Pending"
                    cardName='py-1 wwork_img cursor'
                    imgPath='./assets/img/completed1.png'
                    imgPathsecond='./assets/img/pending.png'
                    WaterAssignMainWorkCardNavigate1={WaterAssignMainWorkCardNavigate1}
                    cardHeading='Operation Works'
                    title2="Operation Completed"
                    searchNametitle2="OperationCompleted"
                    PendingCount={Countdata.OperationPendingTotalCount ? Countdata.OperationPendingTotalCount : '0'}
                    CompletedCount={Countdata.OperationCompletedTotalCount ? Countdata.OperationCompletedTotalCount : '0'}
                />

            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0">
                <WaterAssignMainWorkCard
                    title="Electrical Work Maintenance"
                    title1="Electric Pending"
                    cardName='py-1 wwork_img cursor'
                    imgPath='./assets/img/completed1.png'
                    imgPathsecond='./assets/img/pending.png'
                    count='2'
                    // navLink='/preventivecommondata'
                    WaterAssignMainWorkCardNavigate1={WaterAssignMainWorkCardNavigate1}
                    cardHeading='Electrical Work Maintenance'
                    title2="Electric Completed"
                    searchNametitle2="ElectricCompleted"
                    PendingCount={Countdata.ElectricalPendingTotalCount ? Countdata.ElectricalPendingTotalCount : '0'}
                    CompletedCount={Countdata.ElectricalCompletedTotalCount ? Countdata.ElectricalCompletedTotalCount : '0'}
                />
            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0">
                <WaterAssignMainWorkCard
                    title="Mechanical Work Maintainance"
                    title1="Mechanical Pending"
                    cardName='py-1 wwork_img cursor'
                    imgPath='./assets/img/completed1.png'
                    imgPathsecond='./assets/img/pending.png'
                    count='98'
                    // navLink='/preventivecommondata'
                    WaterAssignMainWorkCardNavigate1={WaterAssignMainWorkCardNavigate1}
                    cardHeading='Mechanical Work Maintainance'
                    title2="Mechanical Completed"
                    searchNametitle2="CivilCompleted"
                    PendingCount={Countdata.MechanicalPendingTotalCount ? Countdata.MechanicalPendingTotalCount : '0'}
                    CompletedCount={Countdata.MechanicalCompletedTotalCount ? Countdata.MechanicalCompletedTotalCount : '0'}
                />
            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2 mb-lg-0">
                <WaterAssignMainWorkCard
                    title="Civil Work Maintenance"
                    title1="Civil Pending"
                    cardName='py-1 wwork_img cursor'
                    imgPath='./assets/img/completed1.png'
                    imgPathsecond='./assets/img/pending.png'
                    count='98'
                    // navLink='/preventivecommondata'
                    WaterAssignMainWorkCardNavigate1={WaterAssignMainWorkCardNavigate1}
                    cardHeading='Civil Work Maintenance'
                    title2="Civil Completed"
                    searchNametitle2="CivilCompleted"
                    PendingCount={Countdata.CivilPendingTotalCount ? Countdata.CivilPendingTotalCount : '0'}
                    CompletedCount={Countdata.CivilCompletedTotalCount ? Countdata.CivilCompletedTotalCount : "0"}
                />
            </div>

        </div>

    )

}
